import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import CompteDeTiersComponent from '../../../components/Mouvement/Panel/CompteDeTiersComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class CompteDeTiersPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.COMPTE_DE_TIERS;
		this.icon = { name: 'user doctor' };
	}

	getLibelle = () => 'Compte de tiers';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.identifiantCompteTiers);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<CompteDeTiersComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default CompteDeTiersPanel;
